/**
 * Classifies the keys of an AI-produced `DraftsSearchFilter` into three buckets so the chip row
 * knows what to render:
 *  - keys with a dedicated chip (`CHIP_RENDERED_KEYS`) / a top-level group chip (`TOP_LEVEL_RENDERED_KEYS`),
 *  - keys deliberately not surfaced (`SILENT_KEYS`),
 *  - everything else, returned by `unknownFilterChipKeys`/`unknownArmChipKeys` to be shown as generic "Unknown" chips.
 *
 * The `<FilterKey>` annotation on each Set literal is the load-bearing part: it forces every listed key to be a
 * real `DraftsSearchFilter` key at compile time, so a renamed/removed schema field breaks the build here instead
 * of silently producing an Unknown chip. The sets are typed `ReadonlySet<string>` only so lookups accept the
 * arbitrary string keys coming off `Object.entries`.
 */ const CHIP_RENDERED_KEYS = new Set([
    'agreementName',
    'clientName',
    'contactName',
    'status',
    'effectiveDate',
    'effectiveDateMode',
    'lastUpdatedAt',
    'lastModifiedBy',
    'paymentSettings',
    'agreementSettings',
    'services',
    'packages',
    'bundles'
]);
const TOP_LEVEL_RENDERED_KEYS = new Set([
    'and',
    'or'
]);
// contactId is programmatic-only — the AI emits clientName from natural language, never contactId — so it is intentionally silent.
const SILENT_KEYS = new Set([
    'version',
    'not',
    'contactId'
]);
const presentFieldKeys = (predicate)=>Object.entries(predicate).filter((param)=>{
        let [, value] = param;
        return value != null;
    }).map((param)=>{
        let [key] = param;
        return key;
    });
export const unknownFilterChipKeys = (filter)=>presentFieldKeys(filter).filter((key)=>!CHIP_RENDERED_KEYS.has(key) && !TOP_LEVEL_RENDERED_KEYS.has(key) && !SILENT_KEYS.has(key));
export const unknownArmChipKeys = (predicate)=>presentFieldKeys(predicate).filter((key)=>!CHIP_RENDERED_KEYS.has(key) && !SILENT_KEYS.has(key));
